<template>
  <div :class="className">
    <v-menu
      v-model="menuStartDate"
      transition="scale-transition"
      offset-y
      max-width="290px"
      min-width="290px"
    >
      <template v-slot:activator="{ on }">
        <v-icon size="15" class="mt-2 mr-1 pull-left"
          >far fa-calendar-alt</v-icon
        >

        <v-text-field
          v-model="startDateFormatted"
          v-on="on"
          placeholder="Start date"
          readonly
          class="pull-left pt-0 mt-0"
          :class="{
            small: size === 'small',
          }"
        ></v-text-field>
      </template>
      <v-date-picker
        v-model="startDate"
        no-title
        :max="endDate"
        color="primary"
        @input="handleInputStartDate"
      ></v-date-picker>
    </v-menu>

    <div class="mx-1 mt-1 pull-left hyp-to-text">to</div>

    <v-menu
      v-model="menuEndDate"
      transition="scale-transition"
      offset-y
      max-width="290px"
      min-width="290px"
    >
      <template v-slot:activator="{ on }">
        <v-text-field
          v-model="endDateFormatted"
          v-on="on"
          placeholder="End date"
          readonly
          class="pull-left pt-0 mt-0"
          :class="{
            small: size === 'small',
          }"
        ></v-text-field>
      </template>
      <v-date-picker
        v-model="endDate"
        no-title
        :min="startDate"
        color="primary"
        @input="handleInputEndDate"
      ></v-date-picker>
    </v-menu>

    <div class="mx-1 mt-2 pull-left hyp-to-text">
      <v-icon
        v-if="startDate && endDate"
        size="15"
        class="hyp-x-icon ml-1"
        @click="reset"
        >fas fa-times</v-icon
      >
    </div>

    <div class="clearfix"></div>
  </div>
</template>

<script>
import { getFormattedDate } from "@/common/date.utilities";

const EMITTED_ACTIONS = {
  CHANGE: "change",
};

export default {
  name: "DateRangePicker",
  props: {
    refresh: {
      type: String,
    },
    start: {
      type: String,
    },
    end: {
      type: String,
    },
    className: {
      type: String,
    },
    size: {
      validator: function (value) {
        return ["small", "large"].indexOf(value) !== -1;
      },
    },
  },
  data: function () {
    let start = this.start ? this.start : null;
    let end = this.end ? this.end : null;
    return {
      menuStartDate: false,
      startDate: start,
      menuEndDate: false,
      endDate: end,
    };
  },
  computed: {
    startDateFormatted() {
      if (this.startDate) {
        return getFormattedDate(this.startDate);
      }
      return null;
    },
    endDateFormatted() {
      if (this.endDate) {
        return getFormattedDate(this.endDate);
      }
      return null;
    },
  },
  methods: {
    reset() {
      this.startDate = null;
      this.endDate = null;
      this.emitChange();
    },
    handleInputStartDate() {
      this.menuStartDate = false;
      if (this.startDate && this.endDate) {
        this.emitChange();
      }
    },
    handleInputEndDate() {
      this.menuEndDate = false;
      if (this.startDate && this.endDate) {
        this.emitChange();
      }
    },
    emitChange() {
      this.$emit(EMITTED_ACTIONS.CHANGE, {
        start: this.startDate,
        end: this.endDate,
      });
    },
  },
  watch: {
    refresh: {
      handler(newValue, oldValue) {
        if (newValue != oldValue) {
          this.startDate = null;
          this.endDate = null;
        }
      },
    },
  },
};
</script>

<style>
.small input {
  font-size: 12px !important;
  text-align: center !important;
  color: rgba(0, 0, 0, 0.54) !important;
}
</style>

<style scoped>
.small {
  width: 75px !important;
}
.hyp-to-text {
  color: rgba(0, 0, 0, 0.54) !important;
}
.hyp-x-icon {
  position: relative;
  top: -2px;
}
</style>
